import {resolveMutation} from 'store/modules/tabs/tabManagerFactory'

export default (moduleName, routeName = null, tabIndex = null) => {
    const mutationType = resolveMutation(moduleName),
        alternativeMutation = resolveMutation(moduleName, true),
        selector = `ul.${moduleName} li > a`

    return {
        created () {
            if (!_.isNull(tabIndex)) {
                this.$store.commit(mutationType, tabIndex)
                this.$store.commit(alternativeMutation, true)
            }
        },

        mounted () {
            if (routeName)
                $(selector).click((e) => {
                    let params = this.$route.params
                    this.$router.push({name: routeName, params})
                    this.$store.commit(alternativeMutation, false)
                })
        },

        destroyed () {
            if (routeName)
                $(selector).unbind('click')
        },
    }
}



// WEBPACK FOOTER //
// ./client/mixins/alternativeTab.js